export default __webpack_public_path__ + "assets/images/9e3cf5c5549108e8d7bad3fe48672ebe.png";